module.exports = __webpack_public_path__ + "media/images/icons/engagement-aa445885b7437a7c9870347a26be23cf.png";